module.exports = __webpack_public_path__ + "static/media/font_bold.bee1d259.woff";